const secModules = {
  student: "e2ab3f04-b958-4755-8a1b-da0b75920104"
};

export default secModules;
